import * as React from 'react';

import type { Stream } from 'stores/streams/StreamsStore';
import { Tooltip, StatusIcon } from 'components/common';
import PreviewLakeLogsButton from 'data-lake/components/PreviewLakeLogsButton';
import useFeature from 'hooks/useFeature';
import useStreamDataLakeEnabledStatus from 'data-lake/hooks/useStreamDataLakeEnabledStatus';

type Props = {
  stream: Stream;
};

const DataLakeCell = ({ stream }: Props) => {
  const { data: enabled, isFetching } = useStreamDataLakeEnabledStatus(stream.id);
  const previewFeatureIsEnabled = useFeature('data_warehouse_search');

  if (!stream.is_editable || isFetching) {
    return null;
  }

  const isDataLakeEnabled = enabled || false;

  if (previewFeatureIsEnabled && isDataLakeEnabled) {
    return <PreviewLakeLogsButton streamId={stream.id} />;
  }

  return (
    <Tooltip withArrow position="right" label={`Data lake is ${isDataLakeEnabled ? 'enabled' : 'disabled'}`}>
      <StatusIcon active={isDataLakeEnabled} />
    </Tooltip>
  );
};

export default DataLakeCell;
